import { getPublicUrl } from '@sitecore-jss/sitecore-jss-nextjs/utils';

export const formatLocationUrl = (locationID: string, name: string) => {
  const url = `${getPublicUrl()}/locations/${name
    ?.toLowerCase()
    ?.split(' ')
    ?.join('-')}-${locationID?.replace('LOC', '')?.replace(/^0+/, '')}`;

  return url;
};

export const formatProviderUrl = (
  externalID: string,
  firstName: string,
  lastName: string
) => {
  const url = `${getPublicUrl()}/providers/${firstName?.toLowerCase()}-${lastName?.toLowerCase()}-${externalID}`;

  return url;
};

export const formatSearchResultUrl = (link: string) => {
  const url = `${getPublicUrl()}${link}`;

  return url;
};
